import React from 'react';
import Metrics from '../../TNOMediaKit/components/Metrics';

const METRICS_SECTION = {
  overline: 'Métricas',
  title: 'Audiencia TNO Network',
  description:
    'Chemical se apoya en el alcance real del ecosistema TNO: tráfico web y editorial, comunidad en redes y producción en vivo y On-Demand.',
};

const METRICS = [
  {
    value: '30000',
    label: 'Visitas mensuales al ecosistema TNO',
    subtitle: 'Tráfico mensual en plataforma web y contenido editorial.',
    icon: 'LanguageIcon',
    suffix: '+',
  },
  {
    value: '400000',
    label: 'Cuentas alcanzadas en Instagram',
    subtitle: 'Más de 400 mil cuentas alcanzadas en la cuenta de TNO Network al cierre de mayo.',
    icon: 'InstagramIcon',
    suffix: '+',
  },
  {
    value: '90000',
    label: 'Seguidores en todas las redes',
    subtitle: 'Más de 90 mil entre YouTube, Instagram, Facebook y X (Twitter) del ecosistema TNO.',
    icon: 'YouTubeIcon',
    suffix: '+',
  },
  {
    value: '40',
    label: 'Producciones originales On-Demand',
    subtitle: 'Biblioteca desarrollada en el TNO Media Lab.',
    icon: 'OndemandVideoIcon',
    suffix: '+',
  },
  {
    value: '25',
    label: 'Programas en vivo por semana',
    subtitle: 'Señal con distribución global por TNO Network.',
    icon: 'LiveTvIcon',
    suffix: '+',
  },
];

const MetricsChemical = () => (
  <Metrics metrics={METRICS} content={METRICS_SECTION} hideAudienceImage />
);

export default MetricsChemical;
